import { addDatapointConfig } from 'owa-analytics-actions';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/lightRPStore';
import { saveIsLightRPOnToStorage } from '../utils/localStorage';

const toggleLightRPMutator: () => void = mutatorAction('toggleLightRPState', (): void => {
    const lightRPStore = getStore();

    lightRPStore.isLightRPOn
        ? /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
           * Baseline. DO NOT COPY AND PASTE!
           *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
          addDatapointConfig('ToggleLightRPOff', undefined, undefined, {
              isLightRPOn: !lightRPStore.isLightRPOn,
          })
        : /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
           * Baseline. DO NOT COPY AND PASTE!
           *	> Argument at index 1 for addDatapointConfig must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
          addDatapointConfig('ToggleLightRPOn', undefined, undefined, {
              isLightRPOn: !lightRPStore.isLightRPOn,
          });

    lightRPStore.isLightRPOn = !lightRPStore.isLightRPOn;
    saveIsLightRPOnToStorage(lightRPStore.isLightRPOn);
});
export default toggleLightRPMutator;
